import { getLocale } from "../runtime";

const sv_ptcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Portugal`
};

const ptcountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_ptcountry(inputs)
	return "ptCountry";
};

export { ptcountry as "ptCountry" };